import { toast } from "sonner";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CSE_MESSAGES_QUERY_KEY } from "@/features/cse-messages/hooks/useCseMessages";
import { dismissCseMessage } from "@/features/cse-messages/services/cseMessages.service";
import type { CseMessage } from "@/features/cse-messages/types/cseMessage.type";

const DISMISS_ERROR_MESSAGE = "Impossible de fermer le message. Veuillez réessayer.";

// Retrait optimiste : la disparition du message (et l'avancement de la file
// des modales) est pilotée par le cache. Rollback si le serveur refuse.
export const useDismissCseMessage = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: dismissCseMessage,
    onMutate: async (messageId: string) => {
      await queryClient.cancelQueries({ queryKey: CSE_MESSAGES_QUERY_KEY });
      const previousMessages = queryClient.getQueryData<CseMessage[]>(CSE_MESSAGES_QUERY_KEY);

      queryClient.setQueryData<CseMessage[]>(
        CSE_MESSAGES_QUERY_KEY,
        (messages) => messages?.filter((message) => message.id !== messageId) ?? [],
      );

      return { previousMessages };
    },
    onError: (_error, _messageId, context) => {
      if (context?.previousMessages) {
        queryClient.setQueryData(CSE_MESSAGES_QUERY_KEY, context.previousMessages);
      }
      toast.error(DISMISS_ERROR_MESSAGE);
    },
  });
};
